 import { TreeNode } from "primeng/api";

export class LoginResponse {
  access_token: string;
  secret_Keyforlogin: string;
  refresh_token: string;
  scope: string;
  token_type: string;
  expires_in: number;
  user_id: number;
  error_description: string;
  error: string;
  tokenHasExpired: boolean;
  userInfo: object;
  userProfile: object;
  refrenceDetail: object;
  schemaName: string;
  permissions: any[];
  userRoles : any[];
  userSelectedRoleID : number;
  userSelectedOfficeID : number;
  permissionTestObj:TreeNode[];
}
